import React from "react";
import "./index.scss";
import RadioGroup from "devextreme-react/radio-group";
import { IMdaeRadioGroup } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";
const MdaeRadioGroup: React.FC<IMdaeRadioGroup> = (props) => {
  const dispatch = useDispatch();
  return (
    <div className={"sys-mdae-radio-group-container"}>
      <RadioGroup
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_RADIO_GROUP,
            e.component,
            dispatch
          );
        }}
      ></RadioGroup>
    </div>
  );
};
export default MdaeRadioGroup;
